import styled from "styled-components";

import { ComboboxInputIcon } from "components/ui/Combobox/ComboboxInput/ComboboxInputIcon";
import { ComboboxInputIcons } from "components/ui/Combobox/ComboboxInput/ComboboxInputIcons";
import { ComboboxOptions, ItemValue } from "components/ui/Combobox/combobox.types";
import { Icon } from "components/ui-deprecated";

const ComboboxInputContainer = styled.div`
    width: 100%;

    display: flex;
    align-items: center;

    background-color: ${({ theme }) => theme.color.white};
    border-radius: 0.25rem;
    box-shadow: 0 2px 5px #dedbd666;
    outline: transparent;
`;

const ComboboxInputStyled = styled.input`
    width: 100%;
    padding: 0.5rem 1rem;

    display: inline-block;

    background: none;
    border: none;
    outline: none;

    text-overflow: ellipsis;
`;

type Props<TValue extends ItemValue> = {
    comboboxValue: TValue | null;
    value: string | null;
    onChange: (value: string) => void;
    onBlur: (event: React.FocusEvent<HTMLInputElement>) => void;
    isMenuOpen: boolean;
    onMenuToggleClick: () => void;
    onReset: () => void;
    options?: ComboboxOptions;
};

const ComboboxInput = <TValue extends ItemValue>(props: Props<TValue>) => {
    const { value, options, comboboxValue } = props;
    const placeholder = options?.placeholder ?? "Select...";
    const hideDeselect = options?.hideDeselect ?? false;

    return (
        <ComboboxInputContainer className={"select-input-wrapper"}>
            <ComboboxInputStyled
                type={"text"}
                value={value ?? ""}
                placeholder={placeholder}
                onChange={(e) => props.onChange(e.target.value)}
                onBlur={props.onBlur}
                size={1}
            />
            <ComboboxInputIcons>
                {!hideDeselect && comboboxValue !== null && (
                    <ComboboxInputIcon onClick={props.onReset}>
                        <Icon icon={`times`} />
                    </ComboboxInputIcon>
                )}
                <ComboboxInputIcon onClick={props.onMenuToggleClick}>
                    <Icon icon={`angle-${props.isMenuOpen ? "up" : "down"}`} />
                </ComboboxInputIcon>
            </ComboboxInputIcons>
        </ComboboxInputContainer>
    );
};

export { ComboboxInput };
